import { render, staticRenderFns } from "./RrcvPL.vue?vue&type=template&id=3ec016c2"
import script from "./RrcvPL.vue?vue&type=script&lang=js"
export * from "./RrcvPL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports